import { CalculateModalComponent } from '@innogy/become-a-customer/calculate';
import {
  RevertFormState,
  SaveFormState,
} from '@innogy/become-a-customer/shared';
import type { TypedComponentRendering } from '@core/jss-models';
import type { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import type { Store } from '@ngrx/store';
import type { ComponentRef } from '@angular/core';

/**
 * Workaround to get the component instance reference
 * @see https://github.com/ng-bootstrap/ng-bootstrap/issues/4664
 */
function getComponentRef<T>(modalRef: NgbModalRef): ComponentRef<T> {
  return modalRef['_contentRef'].componentRef as ComponentRef<T>;
}

export const openAdjustCalculationModal = (
  modalService: NgbModal,
  store: Store,
  rendering?: TypedComponentRendering<any>
) => {
  const modalRef = modalService.open(CalculateModalComponent, {
    centered: true,
    keyboard: true,
  });

  const componentRef = getComponentRef(modalRef);
  componentRef.setInput('rendering', rendering);

  modalRef.result.catch((result) => {
    if (result === 0 || result === 'dismiss') {
      store.dispatch(RevertFormState());
    }
  });

  store.dispatch(SaveFormState());
};
